// Base 6 diagnostic questions (12 questions across 5 spheres)
const base6 = [
    // ── I Sfera: Bendroji energija ir savimoka — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai artimam žmogui staiga prireikia mano pagalbos ar palaikymo:',
      choices: {
        a: 'Padedu nuoširdžiai ir iš visos širdies, bet neperžengdamas savo galimybių ribų ir neprarasdamas savęs.',
        b: 'Pamirštu savo poreikius ir aukojuosi tiek, kad galiausiai pats lieku visiškai išsekęs ir tuščias.',
        c: 'Padedu tiek, kiek tuo metu turiu jėgų ir laiko, ir stengiuosi neįsivelti labiau, nei galiu pakelti.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Kai aplinkui kyla nesutarimai ar įtampa tarp man rūpimų žmonių:',
      choices: {
        a: 'Ramiai ir taktiškai ieškau būdo visus sutaikyti, nes darna man yra natūrali vertybė.',
        b: 'Jaučiuosi asmeniškai atsakingas už visų ramybę, net kai konfliktas iš tikrųjų nėra mano reikalas.',
        c: 'Įsikišu tik tada, kai matau, kad situacija tiesiogiai liečia mane ar mano artimiausius.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Kai matau, kad kažkas daroma ne taip, kaip, mano manymu, derėtų:',
      choices: {
        a: 'Ramiai išsakau savo nuomonę ar pasiūlymą, bet galutinį sprendimą palieku pačiam žmogui.',
        b: 'Stengiuosi viską perimti ir perdaryti pats arba primygtinai mokau kitus, kaip „teisingai".',
        c: 'Dažniausiai nutyliu ir nesikišu, nebent tai būtų man tikrai svarbus ar principinis dalykas.',
      },
    },
    // ── II Sfera: Darbas ir karjera — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Kai kolegai ar komandos nariui darbe darosi sunku ir jis nespėja:',
      choices: {
        a: 'Mielai padedu ir palaikau, kai turiu galimybę, bet neperimu visos jo atsakomybės sau.',
        b: 'Prisiimu jo darbus ir rūpesčius, net jei dėl to pats nebespėju atlikti savųjų užduočių.',
        c: 'Padedu tik dėl būtiniausių dalykų, o kitką palieku jam pačiam arba bendrai eigai.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Kai dirbu komandoje ar bendrame projekte:',
      choices: {
        a: 'Natūraliai rūpinuosi, kad visiems būtų gera ir saugu dirbti kartu, ir palaikau gerą atmosferą.',
        b: 'Imuosi beveik visos atsakomybės už rezultatą, o paskui jaučiuosi nepastebėtas ir nevertinamas.',
        c: 'Sąžiningai atlieku savo dalį ir stengiuosi pernelyg nesikišti į tai, kaip dirba kiti.',
      },
    },
    // ── III Sfera: Santykiai ir partnerystė — 2 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Kai myliu žmogų ir jis man tampa labai brangus:',
      choices: {
        a: 'Nuoširdžiai juo rūpinuosi, bet kartu leidžiu jam išlikti savimi ir turėti savo erdvę.',
        b: 'Pernelyg globoju, sergstu ir kontroliuoju, nes giliai viduje bijau jį prarasti.',
        c: 'Rūpestį ir jausmus rodau saikingai, kad per daug neapsunkinčiau nei jo, nei savęs.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Kai pajuntu, kad santykiuose atiduodu žymiai daugiau, nei gaunu mainais:',
      choices: {
        a: 'Ramiai ir atvirai pasikalbu apie pusiausvyrą ir abipusį indėlį į mūsų ryšį.',
        b: 'Tyliu, toliau aukojuosi ir po truputį savyje kaupiu nuoskaudą bei nusivylimą.',
        c: 'Pamažu sumažinu, kiek investuoju, ir stebiu, ar santykis natūraliai susibalansuoja.',
      },
    },
    // ── IV Sfera: Finansai ir resursai — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Kai turiu laisvų pinigų ar resursų:',
      choices: {
        a: 'Mielai dalinuosi su artimaisiais, bet kartu nepamirštu pasirūpinti ir savo poreikiais.',
        b: 'Beveik viską išleidžiu kitiems ar jų norams, o savuosius poreikius nustumiu į paskutinę vietą.',
        c: 'Padedu kitiems tik tada, kai esu tikras, kad man pačiam visko užtenka.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Kai artimas žmogus paprašo finansinės pagalbos:',
      choices: {
        a: 'Padedu tiek, kiek tikrai galiu sau leisti, neapsunkindamas savo paties stabilumo.',
        b: 'Atiduodu net paskutinį, net jei dėl to pats lieku be jokios atramos ar atsargos.',
        c: 'Ramiai apsvarstau situaciją ir padedu tik tada, jei tai man saugu ir pakeliama.',
      },
    },
    // ── V Sfera: Savirealizacija ir gyvenimo situacija — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Kai pastebiu, kad per daug jėgų atiduodu rūpindamasis visais aplinkui:',
      choices: {
        a: 'Sąmoningai skiriu laiko ir dėmesio sau, nes žinau, kad pripildyta taurė duoda daugiau.',
        b: 'Visiškai pamirštu save, pervargstu ir tęsiu tol, kol nebelieka jokių jėgų.',
        c: 'Leidžiu sau pailsėti tik tada, kai jaučiu, kad visi kiti jau aprūpinti ir patenkinti.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Kai galvoju apie savo vertę ir vietą kitų gyvenime:',
      choices: {
        a: 'Žinau, kad esu vertingas pats savaime, net ir be nuolatinio aukojimosi ar tarnavimo.',
        b: 'Jaučiuosi tikrai vertingas tik tada, kai esu kitiems naudingas ir reikalingas.',
        c: 'Savo vertę matau, bet dažnai ją vis dar matuoju pagal tai, kiek padedu kitiems.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Kai gyvenime ištinka sunkumai ar skausmingi išbandymai:',
      choices: {
        a: 'Priimu juos ramiai, ieškau vidinės darnos ir tikiu, kad pusiausvyra sugrįš.',
        b: 'Imu kaltinti save arba dar labiau pasineriu į rūpinimąsi kitais, kad nejausčiau savo paties skausmo.',
        c: 'Pergyvenu sunkų laikotarpį, bet pamažu atkuriu savo vidinę pusiausvyrą ir judu toliau.',
      },
    },
  ];

export default base6;
